module.exports = __webpack_public_path__ + "static/img/mobile-web-swiper01.df71cd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life-smart-phone-sales/mobile-web-swiper01.png
// module id = i6OO
// module chunks = 0